import $ from 'jquery';
window.$ = window.jQuery = $;

export function ajaxPostsInit(){
    jQuery(document).ready(function ( $ ) {
        $('.lds-roller').hide();
        var ppp = 2; // Post per page
        var pageNumber = 1;
        var total = jQuery('.totalpages').val();
        jQuery("#load_more").on("click", function ($) { // When btn is pressed.
            jQuery("#load_more").attr("disabled", true); // Disable the button, temp.
            // jQuery("#load_more").text("Loading..."); // Disable the button, temp.
            jQuery("#load_more").hide();
            jQuery('.lds-roller').show();
            pageNumber++;
            var str = '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=more_post_ajax';
            jQuery.ajax({
                type: "POST",
                dataType: "html",
                url: the_ajax_script.ajaxurl,
                data: str,
                success: function (data) {
                    console.log(data, total, pageNumber);
                    var $data = jQuery(data);
                    if ($data.length) {
                        jQuery(".post-loader").append($data);
                        jQuery("#load_more").attr("disabled", false);
                        // jQuery("#load_more").text("Load more"); // Disable the button, temp.
                        jQuery("#load_more").show();
                        jQuery('.lds-roller').hide();
                    } else {
                        jQuery("#load_more").attr("disabled", true);
                    }                
                    if (total <= pageNumber) {
                        jQuery("#load_more").hide();
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
                }
            });
            return false;
        });
    });
}